import { ClientOnly } from 'remix-utils/client-only'
import { MainContent } from './mainContent'
import { H1 } from './typography'

export const ArticlePage = ({ main, children }: any) => (
	<section className="mx-auto mt-8 flex max-w-7xl flex-col items-center px-1 pb-6 lg:row-start-2 lg:row-end-2 lg:px-4 xl:w-11/12 2xl:w-10/12">
		{main && <MainContent main={main} />}
		<ClientOnly fallback={<H1 className="h-[600px]">Loading...</H1>}>
			{() => children}
		</ClientOnly>
	</section>
)
